import React, { useState, useEffect } from "react";
import "./Landing.css";
import "../../styles/global.css";
import ButtonPrimary from '../../components/buttons/ButtonPrimary';
import { FaDiscord, FaTwitter, FaInstagram } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { Link, useLocation } from "react-router-dom";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Topbar from '../../components/topbar/Topbar';
const logo_sm = require('../../assets/images/logo_sm.png');
const info_banner = require('../../assets/images/login_banner.png');
const landing_gif_1 = require('../../assets/images/landingPage/landing_gif_1.gif');
const landing_gif_2 = require('../../assets/images/landingPage/landing_gif_2.gif');
const landing_gif_3 = require('../../assets/images/landingPage/landing_gif_3.gif');


function Landing() {

    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedTopicId, setSelectedTopicId] = useState(null);

    const [topicCount, setTopicCount] = useState(0);  // State for topic count
    const [prerequisiteCount, setPrerequisiteCount] = useState(0);  // State for prerequisite count
    const [loading, setLoading] = useState(true);  // Loading state

    // Fetch topic and prerequisite counts when the component loads
    useEffect(() => {
        // Fetch topic count
        fetch(`/api/graph/getTopicCount`)
            .then(res => res.json())
            .then(data => {
                setTopicCount(data.topicCount);  // Set topic count
            })
            .catch(err => console.error('Error fetching topic count:', err));

        // Fetch prerequisite count
        fetch(`/api/graph/getPrerequisiteCount`)
            .then(res => res.json())
            .then(data => {
                setPrerequisiteCount(data.prerequisiteCount);  // Set prerequisite count
            })
            .catch(err => console.error('Error fetching prerequisite count:', err))
            .finally(() => {
                setLoading(false);  // Set loading to false once both fetches complete
            });
    }, []);

    useEffect(() => {

        if (selectedTopicId !== null && selectedTopicId !== undefined) {
            // A suggestion has been selected; do not fetch suggestions
            setSuggestions([]);
            return;
        }

        if (inputValue === '' || inputValue.length <= 3) {
            setSuggestions([]);
            return;
        }

        // Fetch the suggestions from the backend
        fetch('/api/search/suggestion', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ searchQuery: inputValue })
        })
            .then(res => res.json())
            .then(data => {
                const searchResults = data;
                setSuggestions([...searchResults]);
            })
            .catch(err => console.error(err));
    }, [inputValue, selectedTopicId]);

    const handleChange = (event) => {
        setInputValue(event.target.value);
        setSelectedTopicId(null); // Reset selected topic ID when typing
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        // Check if inputValue is empty or too short
        if (inputValue.trim() === '' || inputValue.length <= 3) {
            // Input is empty or too short; prevent submission and show a toast
            toast.error('Please enter at least 4 characters to search.', {
                position: "top-center",
                autoClose: 5000,
            });
            return;
        }

        if (selectedTopicId !== null && selectedTopicId !== undefined) {
            // Redirect to the selected topic
            window.location.href = `/home?node=${selectedTopicId}`;
        } else {
            // Redirect to the search results page
            window.location.href = `/search?search_query=${encodeURIComponent(inputValue)}`;
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setInputValue(suggestion.name);
        setSelectedTopicId(suggestion.topicId);
        setSuggestions([]); // Clear suggestions after selection
    };

    const handleBlur = () => {
        setTimeout(() => {
            setSuggestions([]);
        }, 10); // Slight delay to allow clicks on suggestions to register
    };

    return (
        <div className="landing-page">
            <Topbar />
            {/* First Part */}
            <div className="top-section">
                <div className="row start-section">
                    <div className="col-12 align-center ">
                        <img src={logo_sm} alt='Takomori Logo' style={{ height: '80px' }} />
                        <h1 className="font-1 margin-top-30">
                            I want to learn <span className="underline">{inputValue || '\u00a0 \u00a0 \u00a0 \u00a0 \u00a0 \u00a0 \u00a0 \u00a0'}</span>
                        </h1>
                        <form className="start-section-searchbar" onSubmit={handleSubmit}>
                            <input
                                type="text"
                                className="form-control fillet-text-box start-section-input margin-btm-15"
                                placeholder="For example: Backpropagation"
                                value={inputValue}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {suggestions.length > 0 && (
                                <ul className="start-section-suggestions">
                                    {suggestions.map((suggestion, index) =>
                                        <li key={index} onMouseDown={() => handleSuggestionClick(suggestion)}>
                                            {suggestion.name}
                                        </li>
                                    )}
                                </ul>
                            )}
                            <div className="row">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <ButtonPrimary type="submit" value="Start" className="tkmr-btn-auto-fit start-section-btn" />
                                </div>
                            </div>
                        </form>
                        <div className="recommended-keywords margin-top-30">
                            <div className="recommended-keywords-list">
                                {[
                                    { name: 'Backpropagation', link: 'https://www.takomori.com/home?node=0' },
                                    { name: 'Machine Learning Course (Intermediate)', link: 'https://www.takomori.com/home/?path=0' },
                                    { name: 'Few-short learning', link: 'https://www.takomori.com/home/?node=89' }
                                ].map((topic, index) => (
                                    <a
                                        key={index}
                                        href={topic.link}
                                        className="recommended-keyword-btn"
                                    >
                                        {topic.name}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                    <hr />
                    {/*<span className="margin-btm-15">Want to track your learning progress?</span>*/}
                    {/*<div className="row">*/}
                    {/*    <div className="col-12 d-flex align-items-center justify-content-center">*/}
                    {/*        <Link to='/login'>*/}
                    {/*            <ButtonPrimary type="submit" value="Login" className="tkmr-btn-auto-fit" />*/}
                    {/*        </Link>*/}
                    {/*        <span className="mx-2">or</span>*/}
                    {/*        <Link to='/login?register=true'>*/}
                    {/*            <ButtonPrimary type="submit" value="Register" className="tkmr-btn-auto-fit" />*/}
                    {/*        </Link>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                <div className="scroll-down-section">
                    <div className="arrow-animation">
                        ⇣
                    </div>
                    <div className="scroll-down-text">
                        Scroll down to learn more
                    </div>
                </div>
            </div>

            {/* Information Section */}
            <div className="info-section container py-5">
                <div className="row align-items-center">
                    <div className="col-12 col-md-6 info-left mb-3 mb-md-0">
                        <img src={info_banner} alt="Knowledge Graph Illustration" className="img-fluid info-banner-img"/>
                    </div>
                    <div className="col-12 col-md-6 info-right">
                        <h3 className="align-center font-1 bold">A structured and organized approach <br /> to learning knowledge.</h3>
                        <p className="align-center font-3 tkmr_gray_primary margin-top-15">Takomori is a learning platform that is built around a <br /> <span className="tkmr_primary_black">Prerequisite Knowledge Graph</span></p>
                        <p className="align-justify font-3 tkmr_gray_primary margin-top-15">This graph organizes knowledge from basic to advanced topics according to their prerequisite. To master a concept or skill, one must first learn the prerequisite knowledge that comes before it.</p>
                    </div>
                </div>
            </div>

            {/* Statistics Section */}
            <div className="stats-section text-center text-white py-5">
                <div className="container">
                    <h2 className="font-1"><a href="/about" className="a-blue">Join us</a> to build the Prerequisite Knowledge Graph</h2>
                    <p className="font-3 tkmr_gray_primary">Currently, we have </p>
                    <div className="row justify-content-center g-1">
                        <div className="col-md-3">
                            <div className="stat-box mb-5 mb-md-0">
                                {loading ? <Skeleton count={1} width={50} /> : <h3>{topicCount.toLocaleString()}</h3>}
                                <h4>Topics</h4>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-box mb-5 mb-md-0">
                                {loading ? <Skeleton count={1} width={50} /> : <h3>{prerequisiteCount.toLocaleString()}</h3>}
                                <h4>Prerequisites</h4>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-box">
                                <h3>2</h3>
                                <h4>Contributors</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div className="features-section container py-5">
                <div className="row mb-4 margin-top-15 flex-md-row-reverse justify-content-center g-1">
                    <div className="col-md-4 d-flex flex-column justify-content-center">
                        <h3 className="font-1 bold">Follow the flow of the graph.</h3>
                        <p className="font-3 tkmr_gray_primary align-justify">Find the topics you want to learn and navigate the prerequisite knowledge graph to achieve your learning goal.</p>
                    </div>
                    <div className="col-md-5">
                        <img src={landing_gif_1} className="feature-img" alt='Follow the flow of the graph.'/>
                    </div>
                </div>

                <div className="row mb-4 margin-top-30 justify-content-center g-1">
                    <div className="col-md-4 d-flex flex-column justify-content-center">
                        <h3 className="font-1 bold">Recommended with the best learning materials.</h3>
                        <p className="font-3 tkmr_gray_primary align-justify">Suggest, vote and learning with the best learning materials recommended by the community.</p>                       
                    </div>
                    <div className="col-md-5">
                        <img src={landing_gif_2} className="feature-img" alt='Recommended with the best learning materials.' />
                    </div>
                </div>

                <div className="row mb-4 margin-top-30 flex-md-row-reverse justify-content-center g-1">
                    <div className="col-md-4 d-flex flex-column justify-content-center">
                        <h3 className="font-1 bold">Proving yourself that you have mastered the topics.</h3>
                        <p className="font-3 tkmr_gray_primary align-justify">Taking challenging tests to verify your understanding of the topics.</p>
                    </div>
                    <div className="col-md-5">
                        <img src={landing_gif_3} className="feature-img" alt='>Proving yourself that you have mastered the topics.' />
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <footer className="site-footer">
                <div className="footer-content">
                    {/*<div className="footer-links">*/}
                    {/*    <a href="#">Privacy Policy</a>*/}
                    {/*    <a href="#">Terms & Conditions</a>*/}
                    {/*    <a href="#">Help</a>*/}
                    {/*    <a href="#">Contact</a>*/}
                    {/*</div>*/}
                    <div className="social-icons">
                        <a href="https://discord.gg/UPB4yEttrZ"><FaDiscord size={30} /></a>
                        <a href="https://twitter.com/Takomori_offic"><FaTwitter size={28} /></a>
                        <a href="https://www.instagram.com/takomori_official/"><FaInstagram size={28} /></a>
                    </div>
                </div>
                <div className="copyright">
                    © 2024 Takomori. All rights reserved.
                </div>
            </footer>
            {/*About*/}
            {/*Team*/}
            {/*Careers*/}
        </div>
    );
}

export default Landing;
